import React, { Component } from 'react';
import Link, { navigateTo } from 'gatsby-link';
import Typist from 'react-typist';
import { slide as Menu } from 'react-burger-menu';
import InputMask from 'react-input-mask';
import Helmet from 'react-helmet';

import Footer from '../../components/footer';
import Icon from '../../components/icon';
import Menubar from '../../components/icon/menu.icon';
import Phone from '../../components/icon/phone.icon';
import Tusk from '../../components/icon/tusk.icon';
import Twitter from '../../components/icon/twitter.icon';
import Heart from '../../components/icon/heart.icon';
import Facebook from '../../components/icon/like.icon';
import Laugh from '../../components/icon/laugh.icon';
import Message from '../../components/icon/message.icon';

export default class contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuOpen: false,
      isOpen: false,
      youtubeId: null
    };
  }

  // This keeps your state in sync with the opening/closing of the menu
  // via the default means, e.g. clicking the X, pressing the ESC key etc.
  handleStateChange(state) {
    this.setState({ menuOpen: state.isOpen });
  }

  // This can be used to close the menu, e.g. when a user clicks a menu item
  closeMenu() {
    this.setState({ menuOpen: false });
  }

  // This can be used to toggle the menu, e.g. when using a custom icon
  // Tip: You probably want to hide either/both default icons if using a custom icon
  // See https://github.com/negomi/react-burger-menu#custom-icons
  toggleMenu = () => {
    this.setState({ menuOpen: !this.state.menuOpen });
  }

  render() {
    const Signature =(
      <svg viewBox='0 0 199 143' xmlns='http://www.w3.org/2000/svg'>
        <g id='Page-1' fill='none' fillRule='evenodd' stroke='#000'>
          <path d='M49.1416016,31.1152344 C75.2822266,8.24153646 94.8652344,-1.73730469 107.890625,1.17871094 C127.428711,5.55273438 107.850586,23.5957031 89.9755859,41.9179687 C72.1005859,60.2402344 48.3701172,84.2607422 61.9423828,84.2607422 C75.5146484,84.2607422 190.460938,39.0410156 174.953125,18.2646484 C159.445313,-2.51171875 97.7431641,14.2675781 89.9755859,20.3095703 C82.2080078,26.3515625 59.3632813,35.0810547 94.2402344,61.4013672 C129.117188,87.7216797 146.483398,106.082031 143.764648,119.708008 C141.045898,133.333984 124.748047,142.709961 102.599609,141.464844 C80.4511719,140.219727 63.8066406,137.329102 63.8066406,119.708008 C63.8066406,102.086914 98.2822266,92.1962891 149.499023,79.2382813 C200.71582,66.2802734 212.223633,59.1152344 177.994141,54.3701172 C143.764648,49.625 68.6064453,41.9443359 27.2304687,45.6464844 C-0.353515625,48.1145833 -6.02669271,50.2369792 10.2109375,52.0136719'
          id='1-stroke' />
          <path d='M65.0527344,50.0185547 C65.811849,72.8219401 67.96875,89.7386068 71.5234375,100.768555'
          id='2-stroke' />
        </g>
      </svg>
    )
    return (
      <div id="outer-container">
        <Helmet>
          <title>Contact | TUSK, Inc.</title>
          <meta name="description" content="We draw on decades of corporate, non-profit, and political victories to empower a new generation of innovators with the hard-won context of yesterday and the tools to shape tomorrow." />
        </Helmet>
        <Menu
          pageWrapId={'page-wrap'}
          width={'75vw'}
          isOpen={this.state.menuOpen}
          customBurgerIcon={false}
          onStateChange={state => this.handleStateChange(state)}
          bodyClassName={'menu-open'}
        >
          <div className="container py-4">
            <h1 className="mt-4 mb-4">New norms. New ideas. New TUSK.</h1>
            <p>Welcome to the new normal: an evolving idea of what it means to be an influencer, a global citizen, a changemaker. “Politics” are no longer confined to campaigns. The new social order bends and breaks with every&nbsp;
              <span className="icon-animation">
                <span>
                  <Icon icon={Twitter} height={24} />
                </span>
                <span>
                  <Icon icon={Heart} height={15} fill={'#e95b4b'} />
                </span>
                <span>
                  <Icon icon={Facebook} height={24} fill={'#238af7'} />
                </span>
                <span>
                  <Icon icon={Laugh} height={15} />
                </span>
                <span>
                  <Icon icon={Message} height={15} />
                </span>
              </span>&nbsp;as disruption reigns supreme. From the classroom to the boardroom—and everywhere in between—agility and insurgency run the show. Get ready.</p>
            <p>Even in this unprecedented era, success relies on experience. TUSK draws on decades of corporate, non-profit, and political victories to empower a new generation of innovators with the hard-won context of yesterday and the tools to shape tomorrow.</p>
            <p>The rules have changed. So have we. Labels mean nothing in this new landscape: If you’re trying to do something extraordinary, we want to help.</p>
            <p>So. Let’s get started.</p>
            <div className="ron">
              {Signature}
              <div className="h6 mb-0 mt-3">- Ron Steslow</div>
              <i>President, TUSK INC</i>
            </div>
            <div className="row">
              <div className="col-md-6">
                <a role="button" tabIndex={0} className="mt-5 btn btn-secondary btn-block" onClick={() => this.toggleMenu()}>
                  Let's Talk
                </a>
              </div>
            </div>
          </div>
        </Menu>
        <div id="page-wrap">
          <div className="container-fluid d-md-block d-none">
            <div className="pt-3 pb-5">
              <button className="btn btn-primary" onClick={() => this.toggleMenu()}>
                <Icon icon={Menubar} width={24} height={30} fill={'#fff'} />
              </button>
            </div>
          </div>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-5 logo-area">
                <button className="btn btn-primary d-inline-block d-md-none" onClick={() => this.toggleMenu()}>
                  <Icon icon={Menubar} width={24} height={30} fill={'#fff'} />
                </button>
                <Link to="/" className="logo" href="#">
                  <Icon icon={Tusk} height={70} fill={'#000'} />
                </Link>
                <h2 className="tagline">Footnotes to Frontrunners.</h2>
                <a className="d-inline-block d-md-none btn btn-primary" href="tel:(202)644-8484">
                  <Icon icon={Phone} width={24} height={30} fill={'#fff'} />
                </a>
                <Link to="/" role="button" tabIndex={0} className="d-none d-md-inline-block mt-md-4 btn btn-lg btn-secondary">
                  Home
                </Link>
              </div>
              <div className="col-md-7 py-3 ml-auto v-center-right">
                <Typist className="h1 mb-5 ml-0 ml-md-4">
                  Contact us.
                </Typist>
                <p className="px-md-4 pl-0">TUSK is not engaging new clients at this time. If there’s an opportunity you’d like us to consider, please feel free to send a note using the contact form.
Otherwise, you can find Ron Steslow’s current work at <a href="https://politicology.com">Politicology.com</a>.</p>
                <form
                  name="contact"
                  action="/contact/success/"
                  method="post"
                  data-netlify="true"
                  data-netlify-honeypot="bot-field"
                  className="px-md-4 pl-0"
                >
                  <input type="hidden" name="form-name" value="contact"/>
                  <div className="form-group">
                    <div className="form-row">
                      <div className="col-md-6 mb-4">
                        <label className="sr-only" for="firstName">First Name</label>
                        <input id="firstName" name="firstName" type="text" className="form-control" placeholder="First name" required/>
                      </div>
                      <div className="col-md-6 mb-4">
                        <label className="sr-only" for="lasttName">Last Name</label>
                        <input id="lastName" name="lastName" type="text" className="form-control" placeholder="Last name" required/>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col mb-4">
                        <label className="sr-only" for="emailAddress">Email Address</label>
                        <input id="emailAddress" name="emailAddress" type="email" className="form-control" placeholder="Email Address" required/>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col mb-4">
                        <label className="sr-only" for="phoneNumber">What is the best number to reach you?</label>
                        <InputMask id="phoneNumber" name="phoneNumber" type="tel" className="form-control" mask="(999) 999-9999" placeholder="Phone Number" srequired/>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col mb-4">
                        <label className="sr-only" for="messageText">How can we help?</label>
                        <textarea id="messageText" name="messageText" className="form-control" rows="3" placeholder="How can we help?" required></textarea>
                      </div>
                    </div>
                    <div class="visually-hidden">
                      <label className="sr-only">Don’t fill this out if you're human: <input name="bot-field"/></label>
                    </div>
                    <div data-netlify-recaptcha></div>
                  </div>
                  <button type="submit" className="btn btn-primary">Submit</button>
                </form>
                <Footer />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/contact/index.js